<template>
    <!-- 使用 div 而非 section，避免全局 .content-az section { overflow:auto; height:100% } 与外层再套一层纵向滚动 -->
    <div class="dp-layout roll-call-page">
        <div class="dp-left">
            <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
        </div>
        <div class="dp-right roll-call-main">
            <div class="toolbar-filter-bar">
                <el-form :inline="true" class="toolbar-filter-form">
                    <div class="toolbar-filter-fields">
                        <el-form-item label="考勤日期">
                            <el-date-picker v-model="queryDate" type="date" value-format="yyyy-MM-dd" placeholder="日期"
                                class="toolbar-field-w-date" />
                        </el-form-item>
                        <el-form-item label="时段">
                            <el-select v-model="timeSlotId" placeholder="时段" filterable class="toolbar-field-w-lg"
                                :disabled="!DepartmentId">
                                <el-option v-for="s in slotOptions" :key="s.Id" :label="slotLabel(s)" :value="s.Id" />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="校区">
                            <el-select v-model="filterCampusId" placeholder="校区" class="toolbar-field-w-xl"
                                :disabled="!DepartmentId || !campusOptions.length" @change="onCampusChanged">
                                <el-option v-for="c in campusOptions" :key="c.Id" :label="c.Name" :value="c.Id" />
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" :loading="statsLoading" icon="el-icon-search" @click="loadStatistics">查询统计</el-button>
                        </el-form-item>
                    </div>
                    <div class="toolbar-filter-actions">
                        <el-button type="warning" icon="el-icon-download" @click="openExportDialog"
                            :disabled="!DepartmentId || !filterCampusId">导出 Excel</el-button>
                    </div>
                </el-form>
            </div>

            <div v-if="displaySchoolStats" class="cr-summary-strip" :class="{ 'is-placeholder': !schoolStats }">
                <div class="cr-summary-strip__row">
                    <div class="cr-summary-strip__lead">
                        <span class="cr-summary-strip__title">校级汇总</span>
                        <span class="cr-summary-strip__sub">状态人数仅统计已点名班级</span>
                        <span v-if="displaySchoolStats.TimeSlotName" class="cr-chip">时段 {{ displaySchoolStats.TimeSlotName }}</span>
                        <span v-if="!schoolStats" class="cr-chip cr-chip--muted">未查询 · 占位</span>
                    </div>
                    <div class="cr-class-meta">
                        <span class="cr-class-meta__item">行政班 <strong>{{ displaySchoolStats.TotalClassCount }}</strong></span>
                        <span class="cr-class-meta__sep">|</span>
                        <span class="cr-class-meta__item cr-class-meta__item--ok">已点名 <strong>{{ displaySchoolStats.RolledCalledClassCount }}</strong></span>
                        <span class="cr-class-meta__sep">|</span>
                        <span class="cr-class-meta__item cr-class-meta__item--bad">未点名 <strong>{{ displaySchoolStats.UnRolledCalledClassCount }}</strong></span>
                    </div>
                    <div class="cr-class-meta">
                        <span class="cr-class-meta__item">全校人数 <strong>{{ displaySchoolStats.TotalStudentCount }}</strong></span>
                        <span class="cr-class-meta__sep">|</span>
                        <span class="cr-class-meta__item cr-class-meta__item--ok">已点名人数 <strong>{{ displaySchoolStats.RolledCalledStudentCount }}</strong></span>
                        <span class="cr-class-meta__sep">|</span>
                        <span class="cr-class-meta__item cr-class-meta__item--bad">未点名人数 <strong>{{ displaySchoolStats.UnRolledCalledStudentCount }}</strong></span>
                    </div>
                </div>
                <div class="cr-summary-strip__stats">
                    <div class="cr-stat-pill cr-stat-pill--ok">
                        <span class="cr-stat-pill__l">正常</span>
                        <span class="cr-stat-pill__n">{{ displaySchoolStats.CountNormal }}</span>
                    </div>
                    <div class="cr-stat-pill cr-stat-pill--warn">
                        <span class="cr-stat-pill__l">迟到</span>
                        <span class="cr-stat-pill__n">{{ displaySchoolStats.CountLate }}</span>
                    </div>
                    <div class="cr-stat-pill cr-stat-pill--warn">
                        <span class="cr-stat-pill__l">早退</span>
                        <span class="cr-stat-pill__n">{{ displaySchoolStats.CountEarlyLeave }}</span>
                    </div>
                    <div class="cr-stat-pill cr-stat-pill--danger">
                        <span class="cr-stat-pill__l">缺勤</span>
                        <span class="cr-stat-pill__n">{{ displaySchoolStats.CountMiss }}</span>
                    </div>
                    <div class="cr-stat-pill cr-stat-pill--neutral">
                        <span class="cr-stat-pill__l">请假</span>
                        <span class="cr-stat-pill__n">{{ displaySchoolStats.CountLeave }}</span>
                    </div>
                    <div class="cr-stat-pill cr-stat-pill--neutral">
                        <span class="cr-stat-pill__l">其他</span>
                        <span class="cr-stat-pill__n">{{ displaySchoolStats.CountOther }}</span>
                    </div>
                </div>
            </div>

            <div class="cr-detail-panel">
                <div class="cr-detail-panel__head">
                    <div class="cr-detail-panel__lead">
                        <span class="cr-detail-panel__title">班级明细</span>
                        <span v-if="classRows.length" class="cr-detail-panel__sub">共 {{ classRows.length }} 个班 · 显示 {{ filteredClassRows.length }} 个</span>
                    </div>
                    <div class="cr-detail-panel__filters">
                        <el-select v-model="classTableFilter" class="toolbar-field-w-lg" placeholder="列表范围">
                            <el-option label="只看有数据的班" value="focus" />
                            <el-option label="非全勤" value="nonFull" />
                            <el-option label="全部班级" value="all" />
                            <el-option label="仅已点名" value="rolled" />
                            <el-option label="仅未点名" value="unrolled" />
                        </el-select>
                        <el-input
                            v-model="classNameKeyword"
                            clearable
                            placeholder="搜索班级名称"
                            prefix-icon="el-icon-search"
                            class="toolbar-field-w-xl"
                        />
                    </div>
                </div>
                <div class="cr-table-wrap tbl-scroll-host">
                    <el-table
                        :data="filteredClassRows"
                        row-key="DepartmentId"
                        size="small"
                        stripe
                        class="cr-table"
                        style="width: 100%"
                        height="100%"
                    >
                    <template slot="empty">
                        <span v-if="!classRows.length" class="table-empty-hint">暂无班级行。请在上文选择<strong>考勤日期</strong>、<strong>时段</strong>后点击「查询统计」。</span>
                        <span v-else class="table-empty-hint">当前筛选下没有班级，可切换为「全部班级」或清空搜索。</span>
                    </template>
                    <el-table-column prop="DepartmentName" label="班级" width="" show-overflow-tooltip />
                    <el-table-column label="点名状态" width="" align="center">
                        <template slot-scope="scope">
                            <el-tag
                                v-if="scope.row.IsRolledCalled === true || scope.row.isRolledCalled === true"
                                type="success"
                                size="mini"
                                effect="plain"
                            >已点名</el-tag>
                            <el-tag v-else type="info" size="mini" effect="plain">未点名</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="应到" width="" align="center" class-name="col-num">
                        <template slot-scope="scope">{{ numCell(scope.row.ExpectedStudentCount) }}</template>
                    </el-table-column>
                    <el-table-column label="正常" width="" align="center" class-name="col-num">
                        <template slot-scope="scope">{{ numCell(scope.row.CountNormal) }}</template>
                    </el-table-column>
                    <el-table-column label="迟到" width="" align="center" class-name="col-num">
                        <template slot-scope="scope">{{ numCell(scope.row.CountLate) }}</template>
                    </el-table-column>
                    <el-table-column label="早退" width="" align="center" class-name="col-num">
                        <template slot-scope="scope">{{ numCell(scope.row.CountEarlyLeave) }}</template>
                    </el-table-column>
                    <el-table-column label="缺勤" width="" align="center" class-name="col-num">
                        <template slot-scope="scope">{{ numCell(scope.row.CountMiss) }}</template>
                    </el-table-column>
                    <el-table-column label="请假" width="" align="center" class-name="col-num">
                        <template slot-scope="scope">{{ numCell(scope.row.CountLeave) }}</template>
                    </el-table-column>
                    <el-table-column label="其他" width="" align="center" class-name="col-num">
                        <template slot-scope="scope">{{ numCell(scope.row.CountOther) }}</template>
                    </el-table-column>
                    <el-table-column width="" align="center" class-name="col-num">
                        <template slot="header">
                            <span>异常</span>
                            <el-tooltip
                                content="迟到 + 早退 + 缺勤 + 请假 + 其他（不含正常）"
                                placement="top"
                            >
                                <i class="el-icon-info cr-col-hint"></i>
                            </el-tooltip>
                        </template>
                        <template slot-scope="scope">{{ numCell(scope.row.AbnormalCount) }}</template>
                    </el-table-column>
                    <el-table-column label="操作人" width="" show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.LastTouchedByName || '—' }}</template>
                    </el-table-column>
                    <el-table-column label="操作时间" width="128" align="center">
                        <template slot-scope="scope">{{ formatDateTime(scope.row.LastTouchedAt) }}</template>
                    </el-table-column>
                    <el-table-column label="操作" width="120" align="center">
                        <template slot-scope="scope">
                            <el-button
                                type="text"
                                class="cr-btn-detail table-op-link"
                                :disabled="!canOpenStudentDetail(scope.row)"
                                @click.stop="openRecordStudents(scope.row)"
                            >学生明细</el-button>
                        </template>
                    </el-table-column>
                    </el-table>
                </div>
            </div>

            <el-dialog
                :visible.sync="exportDialogVisible"
                width="560px"
                append-to-body
                :close-on-click-modal="false"
                custom-class="cr-export-dialog"
                @closed="onExportDialogClosed"
            >
                <div slot="title" class="cr-export-dialog__title-wrap">
                    <div class="cr-export-dialog__title">
                        <i class="el-icon-download" aria-hidden="true"></i>
                        <span class="cr-export-dialog__title-text">导出 Excel</span>
                        <span class="cr-export-dialog__meta">
                            <span class="cr-export-dialog__meta-sep" aria-hidden="true">·</span>
                            <span>{{ exportDialogSlotLabel || "—" }}</span>
                            <span class="cr-export-dialog__meta-sep" aria-hidden="true">·</span>
                            <span>{{ exportDialogCampusName || "—" }}</span>
                        </span>
                    </div>
                </div>
                <div
                    class="cr-export-dialog__body"
                    v-loading="exportLoading"
                    element-loading-text="正在生成 Excel…"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(255, 255, 255, 0.88)"
                >
                    <div class="cr-export-sheet-list">
                        <div class="cr-export-scope-block">
                            <div class="cr-export-scope-row">
                                <label class="cr-export-scope-opt" :class="{ 'is-on': exportOnlyRolledCalled }">
                                    <input v-model="exportOnlyRolledCalled" type="checkbox" class="cr-export-sheet-row__input" />
                                    <span class="cr-export-sheet-row__check" aria-hidden="true"><i class="el-icon-check"></i></span>
                                    <span class="cr-export-scope-opt__text">
                                        <strong>仅已点名</strong>
                                    </span>
                                </label>
                                <label class="cr-export-scope-opt" :class="{ 'is-on': exportOnlyNonFullClasses }">
                                    <input v-model="exportOnlyNonFullClasses" type="checkbox" class="cr-export-sheet-row__input" />
                                    <span class="cr-export-sheet-row__check" aria-hidden="true"><i class="el-icon-check"></i></span>
                                    <span class="cr-export-scope-opt__text">
                                        <strong>仅非全勤</strong>
                                    </span>
                                </label>
                            </div>
                            <p class="cr-export-scope-hint">班级汇总 / 学生明细按此过滤；统计汇总不受影响</p>
                        </div>
                        <div class="cr-export-sheet-row" :class="{ 'is-checked': exportIncludeSummary }">
                            <label class="cr-export-sheet-row__head">
                                <input v-model="exportIncludeSummary" type="checkbox" class="cr-export-sheet-row__input" />
                                <span class="cr-export-sheet-row__check" aria-hidden="true"><i class="el-icon-check"></i></span>
                                <div class="cr-export-sheet-row__label">
                                    <span class="cr-export-sheet-row__title">统计汇总</span>
                                    <span class="cr-export-sheet-row__badge">最多 {{ exportSummaryMaxDays }} 天</span>
                                </div>
                            </label>
                            <div v-if="exportIncludeSummary" class="cr-export-date-panel">
                            <div class="cr-export-date-row">
                            <el-date-picker
                                :value="exportSummaryDateRange[0]"
                                type="date"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                placeholder="开始日期"
                                size="small"
                                prefix-icon="el-icon-date"
                                class="cr-export-date-pick"
                                :clearable="false"
                                :picker-options="exportSummaryStartPickerOptions"
                                @input="(v) => setExportRangePart('exportSummaryDateRange', 0, v)"
                            />
                            <span class="cr-export-date-sep" aria-hidden="true"><i class="el-icon-right"></i></span>
                            <el-date-picker
                                :value="exportSummaryDateRange[1]"
                                type="date"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                placeholder="结束日期"
                                size="small"
                                prefix-icon="el-icon-date"
                                class="cr-export-date-pick"
                                :clearable="false"
                                :picker-options="exportSummaryEndPickerOptions"
                                @input="(v) => setExportRangePart('exportSummaryDateRange', 1, v)"
                            />
                            </div>
                            </div>
                        </div>

                        <div class="cr-export-sheet-row" :class="{ 'is-checked': exportIncludeClass }">
                            <label class="cr-export-sheet-row__head">
                                <input v-model="exportIncludeClass" type="checkbox" class="cr-export-sheet-row__input" />
                                <span class="cr-export-sheet-row__check" aria-hidden="true"><i class="el-icon-check"></i></span>
                                <div class="cr-export-sheet-row__label">
                                    <span class="cr-export-sheet-row__title">班级汇总</span>
                                    <span class="cr-export-sheet-row__badge">最多 {{ exportClassMaxDays }} 天<span v-if="exportOnlyRolledCalled || exportOnlyNonFullClasses"> · <template v-if="exportOnlyRolledCalled">仅已点名</template><template v-if="exportOnlyRolledCalled && exportOnlyNonFullClasses">且</template><template v-if="exportOnlyNonFullClasses">非全勤</template></span></span>
                                </div>
                            </label>
                            <div v-if="exportIncludeClass" class="cr-export-date-panel">
                            <div class="cr-export-date-row">
                            <el-date-picker
                                :value="exportClassDateRange[0]"
                                type="date"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                placeholder="开始日期"
                                size="small"
                                prefix-icon="el-icon-date"
                                class="cr-export-date-pick"
                                :clearable="false"
                                :picker-options="exportClassStartPickerOptions"
                                @input="(v) => setExportRangePart('exportClassDateRange', 0, v)"
                            />
                            <span class="cr-export-date-sep" aria-hidden="true"><i class="el-icon-right"></i></span>
                            <el-date-picker
                                :value="exportClassDateRange[1]"
                                type="date"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                placeholder="结束日期"
                                size="small"
                                prefix-icon="el-icon-date"
                                class="cr-export-date-pick"
                                :clearable="false"
                                :picker-options="exportClassEndPickerOptions"
                                @input="(v) => setExportRangePart('exportClassDateRange', 1, v)"
                            />
                            </div>
                            </div>
                        </div>

                        <div class="cr-export-sheet-row" :class="{ 'is-checked': exportIncludeStudent }">
                            <label class="cr-export-sheet-row__head">
                                <input v-model="exportIncludeStudent" type="checkbox" class="cr-export-sheet-row__input" />
                                <span class="cr-export-sheet-row__check" aria-hidden="true"><i class="el-icon-check"></i></span>
                                <div class="cr-export-sheet-row__label">
                                    <span class="cr-export-sheet-row__title">学生明细</span>
                                    <span class="cr-export-sheet-row__badge">最多 {{ exportStudentMaxDays }} 天 · <template v-if="exportOnlyRolledCalled || exportOnlyNonFullClasses"><template v-if="exportOnlyRolledCalled">仅已点名</template><template v-if="exportOnlyRolledCalled && exportOnlyNonFullClasses">且</template><template v-if="exportOnlyNonFullClasses">非全勤</template>班分 Sheet</template><template v-else>按班分 Sheet</template></span>
                                </div>
                            </label>
                            <div v-if="exportIncludeStudent" class="cr-export-date-panel">
                            <div class="cr-export-date-row">
                            <el-date-picker
                                :value="exportStudentDateRange[0]"
                                type="date"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                placeholder="开始日期"
                                size="small"
                                prefix-icon="el-icon-date"
                                class="cr-export-date-pick"
                                :clearable="false"
                                :picker-options="exportStudentStartPickerOptions"
                                @input="(v) => setExportRangePart('exportStudentDateRange', 0, v)"
                            />
                            <span class="cr-export-date-sep" aria-hidden="true"><i class="el-icon-right"></i></span>
                            <el-date-picker
                                :value="exportStudentDateRange[1]"
                                type="date"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                placeholder="结束日期"
                                size="small"
                                prefix-icon="el-icon-date"
                                class="cr-export-date-pick"
                                :clearable="false"
                                :picker-options="exportStudentEndPickerOptions"
                                @input="(v) => setExportRangePart('exportStudentDateRange', 1, v)"
                            />
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div slot="footer" class="cr-export-dialog__footer">
                    <p v-if="exportLoading && exportIncludeStudent" class="cr-export-dialog__loading-hint">按班生成学生明细，班级较多时约需数秒至十几秒</p>
                    <p v-else-if="exportLoading" class="cr-export-dialog__loading-hint">正在生成 Excel，请稍候…</p>
                    <el-button size="small" :disabled="exportLoading" @click="exportDialogVisible = false">取消</el-button>
                    <el-button type="primary" size="small" :loading="exportLoading" icon="el-icon-download" @click="confirmExport">
                        {{ exportLoading ? "生成中…" : "开始导出" }}
                    </el-button>
                </div>
            </el-dialog>

            <el-dialog
                :title="studentDialogTitle"
                :visible.sync="studentDialogVisible"
                width="780px"
                append-to-body
                custom-class="cr-student-detail-dialog"
                @closed="onStudentDialogClosed"
            >
                <div class="cr-student-detail-toolbar">
                    <el-input
                        v-model="studentDetailKeyword"
                        clearable
                        size="small"
                        placeholder="姓名 / 学号"
                        prefix-icon="el-icon-search"
                        class="cr-student-detail-keyword"
                        @input="onStudentDetailFilterChange"
                    />
                    <el-select
                        v-model="studentDetailStateFilter"
                        clearable
                        size="small"
                        placeholder="出勤状态"
                        class="cr-student-detail-state"
                        @change="onStudentDetailFilterChange"
                    >
                        <el-option label="全部状态" :value="null" />
                        <el-option label="正常" :value="1" />
                        <el-option label="迟到" :value="2" />
                        <el-option label="早退" :value="3" />
                        <el-option label="缺勤" :value="0" />
                        <el-option label="请假" :value="4" />
                        <el-option label="其他" :value="5" />
                    </el-select>
                    <span class="cr-student-detail-count">共 {{ filteredStudentDetailList.length }} 人</span>
                </div>
                <el-table
                    :data="pagedStudentDetailList"
                    v-loading="studentDetailLoading"
                    size="small"
                    stripe
                    border
                    class="cr-student-detail-table"
                    max-height="380"
                >
                    <template slot="empty">
                        <span>暂无学生记录（会话可能尚未生成名册）</span>
                    </template>
                    <el-table-column prop="StuCode" label="学号" width="110" show-overflow-tooltip />
                    <el-table-column prop="StudentName" label="姓名" min-width="90" show-overflow-tooltip />
                    <el-table-column label="出勤" width="80" align="center">
                        <template slot-scope="scope">
                            <el-tag
                                size="mini"
                                effect="plain"
                                :type="rollCallStateTagType(scope.row.CurrentState)"
                            >{{ rollCallStateLabel(scope.row.CurrentState) }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="时间" width="158" align="center">
                        <template slot-scope="scope">{{ formatDateTime(scope.row.LastChangedAt) }}</template>
                    </el-table-column>
                    <el-table-column prop="Remark" label="备注" min-width="100" show-overflow-tooltip />
                </el-table>
                <div class="cr-student-detail-pager">
                    <el-pagination
                        small
                        background
                        layout="sizes, prev, pager, next"
                        :total="filteredStudentDetailList.length"
                        :current-page.sync="studentDetailPage"
                        :page-size.sync="studentDetailPageSize"
                        :page-sizes="[10, 20, 50]"
                        @size-change="onStudentDetailPageSizeChange"
                    />
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { getClassRollCallTimeSlotList, getClassRollCallStatistics, getClassRollCallClassDetail, getCampusList } from '../../api/modules/misc';
import { getClassRollCallRecordStudents, exportClassRollCallStudentDetail } from '../../api/modules/personnel';
import DepartmentPane from "../../components/DepartmentPane";

function todayStr() {
    const d = new Date();
    const p = (n) => (n < 10 ? "0" + n : "" + n);
    return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

/** 从 GetStatistics 的 response 取班级行（兼容属性名差异） */
function extractClassRowsFromStatsResponse(r) {
    if (!r || typeof r !== "object") return [];
    const rows = r.ClassRows != null ? r.ClassRows : r.classRows;
    return Array.isArray(rows) ? rows : [];
}

/** 与后端导出上限一致 */
const EXPORT_SUMMARY_MAX_DAYS = 150;
const EXPORT_CLASS_MAX_DAYS = 31;
const EXPORT_STUDENT_MAX_DAYS = 7;

function shiftYmd(ymd, deltaDays) {
    const d = new Date(String(ymd).replace(/-/g, "/"));
    d.setDate(d.getDate() + deltaDays);
    const p = (n) => (n < 10 ? "0" + n : "" + n);
    return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

function defaultSheetRange(endDate, maxDays) {
    return [shiftYmd(endDate, -(maxDays - 1)), endDate];
}

function countInclusiveDays(startDate, endDate) {
    const start = new Date(String(startDate).replace(/-/g, "/"));
    const end = new Date(String(endDate).replace(/-/g, "/"));
    return Math.floor((end - start) / (24 * 3600 * 1000)) + 1;
}

function validateSheetDateRange(label, include, range, maxDays) {
    if (!include) return { ok: true };
    const startDate = range && range[0];
    const endDate = range && range[1];
    if (!startDate || !endDate) return { ok: false, message: `请选择${label}的日期范围` };
    if (endDate < startDate) return { ok: false, message: `${label}结束日期不能早于开始日期` };
    const days = countInclusiveDays(startDate, endDate);
    if (days > maxDays) {
        return { ok: false, message: `${label}日期范围不能超过 ${maxDays} 天（当前 ${days} 天）` };
    }
    return { ok: true };
}

function parseYmdMs(ymd) {
    return new Date(String(ymd).replace(/-/g, "/")).getTime();
}

function makeExportStartPickerOptions(range, maxDays) {
    return {
        disabledDate: (time) => {
            if (time.getTime() > Date.now()) return true;
            const end = range && range[1];
            if (!end) return false;
            const endMs = parseYmdMs(end);
            const maxSpanMs = (maxDays - 1) * 24 * 60 * 60 * 1000;
            const t = time.getTime();
            return t > endMs || t < endMs - maxSpanMs;
        },
    };
}

function makeExportEndPickerOptions(range, maxDays) {
    return {
        disabledDate: (time) => {
            if (time.getTime() > Date.now()) return true;
            const start = range && range[0];
            if (!start) return false;
            const startMs = parseYmdMs(start);
            const maxSpanMs = (maxDays - 1) * 24 * 60 * 60 * 1000;
            const t = time.getTime();
            return t < startMs || t > startMs + maxSpanMs;
        },
    };
}

async function readBlobErrorMessage(blob) {
    if (!blob) return null;
    const text = typeof blob.text === "function" ? await blob.text() : null;
    if (!text) return null;
    try {
        const j = JSON.parse(text);
        return j.msg || j.message || text;
    } catch (e) {
        return text;
    }
}

export default {
    components: { DepartmentPane },
    data() {
        return {
            DepartmentId: 0,
            campusOptions: [],
            slotOptions: [],
            queryDate: todayStr(),
            exportDialogVisible: false,
            exportSummaryDateRange: [],
            exportClassDateRange: [],
            exportStudentDateRange: [],
            exportSummaryMaxDays: EXPORT_SUMMARY_MAX_DAYS,
            exportClassMaxDays: EXPORT_CLASS_MAX_DAYS,
            exportStudentMaxDays: EXPORT_STUDENT_MAX_DAYS,
            exportIncludeSummary: true,
            exportIncludeClass: true,
            exportIncludeStudent: false,
            /** 导出范围：仅已点名 / 仅非全勤（默认都开） */
            exportOnlyRolledCalled: true,
            exportOnlyNonFullClasses: true,
            timeSlotId: null,
            filterCampusId: null,
            statsLoading: false,
            exportLoading: false,
            schoolStats: null,
            classRows: [],
            /** 班级表：focus=有数据；nonFull=非全勤；all；rolled；unrolled */
            classTableFilter: "focus",
            classNameKeyword: "",
            studentDialogVisible: false,
            studentDialogTitle: "学生明细",
            studentDetailList: [],
            studentDetailLoading: false,
            /** 学生明细弹窗：姓名/学号关键字 */
            studentDetailKeyword: "",
            /** 学生明细弹窗：出勤状态筛选；null=全部 */
            studentDetailStateFilter: null,
            studentDetailPage: 1,
            studentDetailPageSize: 20,
        };
    },
    computed: {
        exportSummaryStartPickerOptions() {
            return makeExportStartPickerOptions(this.exportSummaryDateRange, EXPORT_SUMMARY_MAX_DAYS);
        },
        exportSummaryEndPickerOptions() {
            return makeExportEndPickerOptions(this.exportSummaryDateRange, EXPORT_SUMMARY_MAX_DAYS);
        },
        exportClassStartPickerOptions() {
            return makeExportStartPickerOptions(this.exportClassDateRange, EXPORT_CLASS_MAX_DAYS);
        },
        exportClassEndPickerOptions() {
            return makeExportEndPickerOptions(this.exportClassDateRange, EXPORT_CLASS_MAX_DAYS);
        },
        exportStudentStartPickerOptions() {
            return makeExportStartPickerOptions(this.exportStudentDateRange, EXPORT_STUDENT_MAX_DAYS);
        },
        exportStudentEndPickerOptions() {
            return makeExportEndPickerOptions(this.exportStudentDateRange, EXPORT_STUDENT_MAX_DAYS);
        },
        exportDialogCampusName() {
            const c = (this.campusOptions || []).find((x) => x.Id === this.filterCampusId);
            return c ? c.Name : "";
        },
        exportDialogSlotLabel() {
            const slot = (this.slotOptions || []).find((s) => s.Id === this.timeSlotId);
            return slot ? this.slotLabel(slot) : "";
        },
        /** 已查询用接口数据；仅选校+校区时显示全 0 占位，避免大块空白 */
        displaySchoolStats() {
            if (this.schoolStats) return this.schoolStats;
            if (this.DepartmentId > 0 && this.filterCampusId > 0) {
                const slot = (this.slotOptions || []).find((s) => s.Id === this.timeSlotId);
                return {
                    CountNormal: 0,
                    CountLate: 0,
                    CountEarlyLeave: 0,
                    CountMiss: 0,
                    CountLeave: 0,
                    CountOther: 0,
                    TotalClassCount: 0,
                    RolledCalledClassCount: 0,
                    UnRolledCalledClassCount: 0,
                    TotalStudentCount: 0,
                    RolledCalledStudentCount: 0,
                    UnRolledCalledStudentCount: 0,
                    TimeSlotName: slot ? this.slotLabel(slot) : "",
                };
            }
            return null;
        },
        filteredClassRows() {
            const rows = this.classRows || [];
            const kw = (this.classNameKeyword || "").trim().toLowerCase();
            let out = rows;
            if (kw) {
                out = out.filter((r) => {
                    const name = (r.DepartmentName || r.departmentName || "").toLowerCase();
                    return name.includes(kw);
                });
            }
            const f = this.classTableFilter;
            if (f === "rolled") {
                out = out.filter((r) => r.IsRolledCalled === true || r.isRolledCalled === true);
            } else if (f === "unrolled") {
                out = out.filter((r) => !(r.IsRolledCalled === true || r.isRolledCalled === true));
            } else if (f === "focus") {
                out = out.filter((r) => this.rowHasRollCallActivity(r));
            } else if (f === "nonFull") {
                out = out.filter((r) => this.rowIsNonFullAttendance(r));
            }
            return out;
        },
        /** 学生明细：按姓名/学号与状态过滤后的全量 */
        filteredStudentDetailList() {
            const rows = this.studentDetailList || [];
            const kw = (this.studentDetailKeyword || "").trim().toLowerCase();
            const stateFilter = this.studentDetailStateFilter;
            return rows.filter((r) => {
                if (stateFilter != null && stateFilter !== "" && Number(r.CurrentState != null ? r.CurrentState : r.currentState) !== Number(stateFilter)) {
                    return false;
                }
                if (!kw) return true;
                const name = String(r.StudentName || r.studentName || "").toLowerCase();
                const code = String(r.StuCode || r.stuCode || "").toLowerCase();
                return name.includes(kw) || code.includes(kw);
            });
        },
        /** 学生明细：当前页切片 */
        pagedStudentDetailList() {
            const list = this.filteredStudentDetailList;
            const size = Math.max(1, Number(this.studentDetailPageSize) || 20);
            const page = Math.max(1, Number(this.studentDetailPage) || 1);
            const start = (page - 1) * size;
            return list.slice(start, start + size);
        },
    },
    methods: {
        /** 是否值得在「只看有数据」里展示：已点名、有会话、或任意人数非 0 */
        rowHasRollCallActivity(row) {
            if (!row) return false;
            if (row.IsRolledCalled === true || row.isRolledCalled === true) return true;
            if (row.HasSession === true || row.hasSession === true) return true;
            const sum =
                this.numCell(row.CountNormal) +
                this.numCell(row.CountLate) +
                this.numCell(row.CountEarlyLeave) +
                this.numCell(row.CountMiss) +
                this.numCell(row.CountLeave) +
                this.numCell(row.CountOther) +
                this.numCell(row.AbnormalCount);
            return sum > 0;
        },
        /** 非全勤：已点名且异常人数 > 0（异常含请假）。创建于 2026-09-20 */
        rowIsNonFullAttendance(row) {
            if (!row) return false;
            if (!(row.IsRolledCalled === true || row.isRolledCalled === true)) return false;
            const abnormal = this.numCell(row.AbnormalCount != null ? row.AbnormalCount : row.abnormalCount);
            if (abnormal > 0) return true;
            return (
                this.numCell(row.CountLate) +
                this.numCell(row.CountEarlyLeave) +
                this.numCell(row.CountMiss) +
                this.numCell(row.CountLeave) +
                this.numCell(row.CountOther) >
                0
            );
        },
        numCell(v) {
            const n = Number(v);
            return Number.isFinite(n) ? n : 0;
        },
        /** 考勤日仅显示 yyyy-MM-dd，避免 00:00:00 */
        formatDateOnly(v) {
            if (v == null || v === "") return "—";
            if (typeof v === "string") {
                const s = v.trim();
                if (s.length >= 10) return s.slice(0, 10);
                return s;
            }
            const d = new Date(v);
            if (Number.isNaN(d.getTime())) return "—";
            const p = (n) => (n < 10 ? "0" + n : "" + n);
            return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
        },
        formatDateTime(v) {
            if (v == null || v === "") return "—";
            if (typeof v === "string") {
                const s = v.trim();
                if (s.length >= 19) return s.replace("T", " ").slice(0, 19);
                if (s.length >= 10) return s.slice(0, 10);
                return s;
            }
            const d = new Date(v);
            if (Number.isNaN(d.getTime())) return "—";
            const p = (n) => (n < 10 ? "0" + n : "" + n);
            return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
        },
        rollCallStateLabel(state) {
            const m = {
                0: "缺勤",
                1: "正常",
                2: "迟到",
                3: "早退",
                4: "请假",
                5: "其他",
            };
            const k = Number(state);
            return m[k] !== undefined ? m[k] : "—";
        },
        /** 出勤状态对应 el-tag type。创建于 2026-09-20 */
        rollCallStateTagType(state) {
            const k = Number(state);
            if (k === 1) return "success";
            if (k === 2 || k === 3) return "warning";
            if (k === 0) return "danger";
            if (k === 4) return "info";
            return "";
        },
        currentTimeSlotLabel() {
            const s = this.schoolStats;
            const name = s && (s.TimeSlotName != null ? s.TimeSlotName : s.timeSlotName);
            if (name) return name;
            const slot = (this.slotOptions || []).find((s) => s.Id === this.timeSlotId);
            return slot ? this.slotLabel(slot) : "";
        },
        /**
         * 班级行上的点到会话 Id。兼容 PascalCase / camelCase（直连 API 与网关转写不一致时）。
         * 后端可能将 long 序列化为字符串，原样传给 GetRecordStudents 即可。
         */
        rollCallRowSessionId(row) {
            if (!row) return null;
            const a = row.SessionId;
            const b = row.sessionId;
            const raw = a != null && a !== "" ? a : b;
            if (raw == null || raw === "") return null;
            return raw;
        },
        rowDepartmentId(row) {
            if (!row) return null;
            const v = row.DepartmentId != null ? row.DepartmentId : row.departmentId;
            if (v == null || v === "") return null;
            return v;
        },
        rowHasSessionOrRolled(row) {
            if (!row) return false;
            const hs = row.HasSession === true || row.hasSession === true;
            const rolled = row.IsRolledCalled === true || row.isRolledCalled === true;
            return hs || rolled;
        },
        /** 无 sessionId 时仍允许已点名/已有会话的行点击，打开后再请求 GetClassDetail 补 Id */
        canOpenStudentDetail(row) {
            if (this.rollCallRowSessionId(row)) return true;
            if (!this.rowHasSessionOrRolled(row)) return false;
            const dept = this.rowDepartmentId(row);
            return !!(dept && this.queryDate && this.timeSlotId);
        },
        detailPayloadSessionId(payload) {
            if (!payload) return null;
            const a = payload.SessionId;
            const b = payload.sessionId;
            const raw = a != null && a !== "" ? a : b;
            if (raw == null || raw === "") return null;
            return raw;
        },
        openRecordStudents(row) {
            if (!this.canOpenStudentDetail(row)) {
                this.$message.warning("该班级暂无点到会话，无法查看学生明细");
                return;
            }
            const dateStr = this.formatDateOnly(this.queryDate);
            const slotPart = this.currentTimeSlotLabel() || "—";
            const className = row.DepartmentName || row.departmentName || "";
            this.studentDialogTitle = `学生明细 · ${className} · ${dateStr} · ${slotPart}`;
            this.studentDialogVisible = true;
            this.studentDetailList = [];
            this.studentDetailKeyword = "";
            this.studentDetailStateFilter = null;
            this.studentDetailPage = 1;
            this.studentDetailLoading = true;

            const deptId = this.rowDepartmentId(row);
            let chain = Promise.resolve(this.rollCallRowSessionId(row));
            chain = chain.then((sid) => {
                if (sid) return sid;
                return getClassRollCallClassDetail({
                    departmentId: deptId,
                    date: this.queryDate,
                    timeSlotId: this.timeSlotId,
                }).then((res) => {
                    if (!res.data.success) {
                        this.$message.error(res.data.msg || "无法解析点到会话");
                        return null;
                    }
                    return this.detailPayloadSessionId(res.data.response);
                });
            });

            chain
                .then((sid) => {
                    if (!sid) {
                        this.studentDetailLoading = false;
                        this.$message.warning("该班级暂无点到会话，无法查看学生明细");
                        return null;
                    }
                    return getClassRollCallRecordStudents({ sessionId: sid }).then((res) => ({
                        sid,
                        res,
                    }));
                })
                .then((pack) => {
                    this.studentDetailLoading = false;
                    if (!pack) return;
                    const { res } = pack;
                    if (res.data.success) {
                        this.studentDetailList = res.data.response || [];
                    } else {
                        this.$message.error(res.data.msg || "加载失败");
                    }
                })
                .catch(() => {
                    this.studentDetailLoading = false;
                });
        },
        onStudentDialogClosed() {
            this.studentDetailList = [];
            this.studentDetailKeyword = "";
            this.studentDetailStateFilter = null;
            this.studentDetailPage = 1;
        },
        /** 学生明细筛选变化时回到第一页 */
        onStudentDetailFilterChange() {
            this.studentDetailPage = 1;
        },
        onStudentDetailPageSizeChange() {
            this.studentDetailPage = 1;
        },
        treeNodeClick(data) {
            this.DepartmentId = data.value;
            this.schoolStats = null;
            this.classRows = [];
            this.classNameKeyword = "";
            this.classTableFilter = "focus";
            this.loadCampusAndSlots();
        },
        requireCampus() {
            if (!this.filterCampusId || this.filterCampusId <= 0) {
                this.$message.warning("请选择校区");
                return false;
            }
            return true;
        },
        loadCampusAndSlots() {
            this.campusOptions = [];
            this.slotOptions = [];
            this.timeSlotId = null;
            this.filterCampusId = null;
            if (this.DepartmentId <= 0) return;
            getCampusList({ page: 1, intPageSize: 999, departmentId: this.DepartmentId }).then((res) => {
                if (!res.data.success) return;
                this.campusOptions = res.data.response.data || [];
                if (!this.campusOptions.length) {
                    this.$message.warning("该校暂无校区，无法查询");
                    return;
                }
                this.filterCampusId = this.campusOptions[0].Id;
                this.reloadSlotsForCampus().then(() => this.afterCampusOrSlotsReady());
            });
        },
        afterCampusOrSlotsReady() {
            if (this.queryDate && this.timeSlotId && this.filterCampusId) {
                this.loadStatistics({ silent: true });
            } else {
                this.schoolStats = null;
                this.classRows = [];
            }
        },
        reloadSlotsForCampus() {
            if (this.DepartmentId <= 0 || !this.filterCampusId) {
                this.slotOptions = [];
                this.timeSlotId = null;
                return Promise.resolve();
            }
            return getClassRollCallTimeSlotList({
                schoolId: this.DepartmentId,
                campusId: this.filterCampusId,
            }).then((res) => {
                if (res.data.success) {
                    this.slotOptions = (res.data.response || []).filter((s) => s.IsEnabled);
                    const firstId = this.slotOptions.length ? this.slotOptions[0].Id : null;
                    this.timeSlotId = firstId;
                }
            });
        },
        onCampusChanged() {
            this.schoolStats = null;
            this.classRows = [];
            this.classNameKeyword = "";
            this.reloadSlotsForCampus().then(() => this.afterCampusOrSlotsReady());
        },
        slotLabel(s) {
            const t = s.StartTime && s.EndTime ? ` (${s.StartTime}-${s.EndTime})` : "";
            return s.Name + t;
        },
        /**
         * @param {{ silent?: boolean }} options
         * silent：不弹前置校验；接口失败时 silent 下不弹错误。
         */
        loadStatistics(options = {}) {
            const silent = options.silent === true;
            if (this.DepartmentId <= 0) {
                if (!silent) this.$message.warning("请先在左侧选择学校");
                return;
            }
            if (!this.filterCampusId || this.filterCampusId <= 0) {
                if (!silent) this.$message.warning("请选择校区");
                return;
            }
            if (!this.queryDate || !this.timeSlotId) {
                if (!silent) this.$message.warning("请选择日期和时段");
                if (silent) {
                    this.schoolStats = null;
                    this.classRows = [];
                }
                return;
            }
            const campusId = this.filterCampusId;
            this.statsLoading = true;
            getClassRollCallStatistics({
                schoolDepartmentId: this.DepartmentId,
                date: this.queryDate,
                timeSlotId: this.timeSlotId,
                mode: "class",
                campusId,
                gradeDepartmentId: 0,
            })
                .then((res) => {
                    this.statsLoading = false;
                    if (res.data.success && res.data.response) {
                        const r = res.data.response;
                        this.schoolStats = r.School || r.school;
                        this.classRows = extractClassRowsFromStatsResponse(r);
                    } else {
                        if (!silent) this.$message.error(res.data.msg || "加载失败");
                    }
                })
                .catch(() => {
                    this.statsLoading = false;
                });
        },
        openExportDialog() {
            if (this.DepartmentId <= 0) {
                this.$message.warning("请先在左侧选择学校");
                return;
            }
            if (!this.requireCampus()) return;
            if (!this.queryDate || !this.timeSlotId) {
                this.$message.warning("请选择考勤日期和时段后再导出");
                return;
            }
            const endDate = this.queryDate;
            this.exportSummaryDateRange = defaultSheetRange(endDate, EXPORT_SUMMARY_MAX_DAYS);
            this.exportClassDateRange = defaultSheetRange(endDate, EXPORT_CLASS_MAX_DAYS);
            this.exportStudentDateRange = defaultSheetRange(endDate, EXPORT_STUDENT_MAX_DAYS);
            this.exportIncludeSummary = true;
            this.exportIncludeClass = true;
            this.exportIncludeStudent = false;
            this.exportOnlyRolledCalled = true;
            this.exportOnlyNonFullClasses = true;
            this.exportDialogVisible = true;
        },
        onExportDialogClosed() {
        },
        setExportRangePart(rangeKey, partIndex, val) {
            const cur = Array.isArray(this[rangeKey]) ? [...this[rangeKey]] : ["", ""];
            cur[partIndex] = val || "";
            if (cur[0] && cur[1] && cur[0] > cur[1]) {
                if (partIndex === 0) cur[1] = cur[0];
                else cur[0] = cur[1];
            }
            this[rangeKey] = cur;
        },
        confirmExport() {
            if (!this.exportIncludeSummary && !this.exportIncludeClass && !this.exportIncludeStudent) {
                this.$message.warning("请至少勾选一项导出内容");
                return;
            }
            const checks = [
                validateSheetDateRange("统计汇总", this.exportIncludeSummary, this.exportSummaryDateRange, EXPORT_SUMMARY_MAX_DAYS),
                validateSheetDateRange("班级汇总", this.exportIncludeClass, this.exportClassDateRange, EXPORT_CLASS_MAX_DAYS),
                validateSheetDateRange("学生明细", this.exportIncludeStudent, this.exportStudentDateRange, EXPORT_STUDENT_MAX_DAYS),
            ];
            const failed = checks.find((c) => !c.ok);
            if (failed) {
                this.$message.warning(failed.message);
                return;
            }
            const campusId = this.filterCampusId;
            const payload = {
                schoolDepartmentId: this.DepartmentId,
                timeSlotId: this.timeSlotId,
                campusId,
                gradeDepartmentId: 0,
                includeSummary: this.exportIncludeSummary === true,
                includeClass: this.exportIncludeClass === true,
                includeStudent: this.exportIncludeStudent === true,
                onlyRolledCalled: this.exportOnlyRolledCalled === true,
                onlyNonFullClasses: this.exportOnlyNonFullClasses === true,
            };
            if (this.exportIncludeSummary) {
                payload.summaryStartDate = this.exportSummaryDateRange[0];
                payload.summaryEndDate = this.exportSummaryDateRange[1];
            }
            if (this.exportIncludeClass) {
                payload.classStartDate = this.exportClassDateRange[0];
                payload.classEndDate = this.exportClassDateRange[1];
            }
            if (this.exportIncludeStudent) {
                payload.studentStartDate = this.exportStudentDateRange[0];
                payload.studentEndDate = this.exportStudentDateRange[1];
            }
            this.exportLoading = true;
            exportClassRollCallStudentDetail(payload)
                .then(async (res) => {
                    this.exportLoading = false;
                    const blob = res.data;
                    if (!blob || blob.size === 0) {
                        this.$message.error("导出失败：无数据");
                        return;
                    }
                    const isJson =
                        (blob.type && blob.type.indexOf("application/json") !== -1) ||
                        (blob.type && blob.type.indexOf("text/plain") !== -1);
                    if (isJson) {
                        const msg = await readBlobErrorMessage(blob);
                        this.$message.error(msg || "导出失败");
                        return;
                    }
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = `班级点到导出_${Date.now()}.xlsx`;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    window.URL.revokeObjectURL(url);
                    this.$message.success("已开始下载");
                    this.exportDialogVisible = false;
                })
                .catch(async (err) => {
                    this.exportLoading = false;
                    const data = err && err.response && err.response.data;
                    if (data instanceof Blob) {
                        const msg = await readBlobErrorMessage(data);
                        if (msg) {
                            this.$message.error(msg);
                            return;
                        }
                    }
                    this.$message.error((err && err.message) || "导出失败");
                });
        },
    },
};
</script>

<style scoped>
.roll-call-page.dp-layout {
    min-height: 0;
}
.roll-call-page .dp-left {
    align-self: stretch;
    max-height: 100%;
}
.roll-call-main {
    flex: 1;
    min-width: 0;
    min-height: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
    overflow: hidden;
}
.roll-call-main > .toolbar-filter-bar {
    flex-shrink: 0;
    margin-bottom: 0;
}

/* 校级汇总：紧凑信息条 */
.cr-summary-strip {
    flex-shrink: 0;
    padding: 10px 12px;
    border: 1px solid #e8edf3;
    border-radius: 10px;
    background: linear-gradient(180deg, #fbfcfe 0%, #f8fafc 100%);
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
    display: flex;
    flex-direction: column;
    gap: 8px;
}
.cr-summary-strip.is-placeholder {
    opacity: 0.92;
}
.cr-summary-strip__row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 8px 12px;
}
.cr-summary-strip__lead {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px 10px;
    min-width: 0;
}
.cr-summary-strip__title {
    font-size: 14px;
    font-weight: 600;
    color: #1e293b;
}
.cr-summary-strip__sub {
    font-size: 12px;
    color: #64748b;
}
.cr-chip {
    font-size: 12px;
    color: var(--btn-primary, #2563eb);
    background: #eff6ff;
    padding: 2px 8px;
    border-radius: 999px;
    line-height: 1.5;
}
.cr-chip--muted {
    color: #64748b;
    background: #f1f5f9;
}
.cr-class-meta {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px 8px;
    font-size: 12px;
    color: #64748b;
    flex-shrink: 0;
}
.cr-class-meta strong {
    font-size: 14px;
    font-weight: 600;
    color: #1e293b;
    font-variant-numeric: tabular-nums;
}
.cr-class-meta__item--ok strong {
    color: #059669;
}
.cr-class-meta__item--bad strong {
    color: #dc2626;
}
.cr-class-meta__sep {
    color: #cbd5e1;
}
.cr-summary-strip__stats {
    display: grid;
    grid-template-columns: repeat(6, minmax(0, 1fr));
    gap: 8px;
}
@media (max-width: 1200px) {
    .cr-summary-strip__stats {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
}
@media (max-width: 768px) {
    .cr-summary-strip__stats {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}
.cr-stat-pill {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    min-height: 40px;
    padding: 6px 10px;
    border-radius: 8px;
    background: #fff;
    border: 1px solid #e8edf3;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.cr-stat-pill__l {
    font-size: 12px;
    color: #64748b;
    white-space: nowrap;
}
.cr-stat-pill__n {
    font-size: 18px;
    font-weight: 600;
    color: #1e293b;
    font-variant-numeric: tabular-nums;
    line-height: 1;
}
.cr-stat-pill--ok {
    border-left: 3px solid #059669;
}
.cr-stat-pill--warn {
    border-left: 3px solid #d97706;
}
.cr-stat-pill--warn .cr-stat-pill__n {
    color: #d97706;
}
.cr-stat-pill--danger {
    border-left: 3px solid #dc2626;
}
.cr-stat-pill--danger .cr-stat-pill__n {
    color: #dc2626;
}
.cr-stat-pill--neutral {
    border-left: 3px solid #cbd5e1;
}

/* 班级明细：占满剩余高度 */
.cr-detail-panel {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    border: 1px solid #e8edf3;
    border-radius: 10px;
    background: #fff;
    overflow: hidden;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}
.cr-detail-panel__head {
    flex-shrink: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 8px 12px;
    padding: 10px 12px;
    border-bottom: 1px solid #f0f2f5;
    background: #fafbfc;
}
.cr-detail-panel__lead {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px 10px;
    min-width: 0;
}
.cr-detail-panel__title {
    font-size: 14px;
    font-weight: 600;
    color: #1e293b;
}
.cr-detail-panel__sub {
    font-size: 12px;
    color: #64748b;
}
.cr-detail-panel__filters {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    margin-left: auto;
}
.cr-table-wrap {
    flex: 1;
    min-height: 0;
    width: 100%;
    overflow: hidden;
}

.cr-table {
    font-size: 12px;
}
.cr-table >>> .el-table__header th {
    background: #f8fafc !important;
    color: #475569;
    font-weight: 600;
    padding: 8px 6px;
    font-size: 12px;
}
.cr-table >>> .el-table__body td {
    padding: 7px 6px;
}
.cr-table >>> .cell {
    line-height: 1.4;
    padding-left: 6px;
    padding-right: 6px;
}
.cr-table >>> .el-table__row:hover > td {
    background: #f8fafc !important;
}
.cr-btn-detail {
    font-weight: 500;
}
.cr-table >>> .cr-btn-detail.is-disabled {
    color: #c0c4cc !important;
    cursor: not-allowed;
}
.cr-col-hint {
    margin-left: 4px;
    font-size: 13px;
    color: #94a3b8;
    cursor: help;
    vertical-align: middle;
}
.table-empty-hint {
    color: #64748b;
    font-size: 13px;
    padding: 20px 12px;
    display: inline-block;
}
</style>

<style>
/* 导出弹窗（append-to-body，不可 scoped） */
.cr-export-dialog.el-dialog {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 12px 40px rgba(15, 23, 42, 0.12);
}
.cr-export-dialog .el-dialog__header {
    padding: 10px 40px 8px 14px;
    border-bottom: 1px solid #f0f2f5;
    background: #fff;
}
.cr-export-dialog .el-dialog__headerbtn {
    top: 10px;
    right: 12px;
}
.cr-export-dialog .el-dialog__body {
    padding: 0 !important;
    background: #f8fafc;
    min-height: 0 !important;
}
.cr-export-dialog .el-dialog__footer {
    padding: 8px 12px 10px;
    border-top: 1px solid #f0f2f5;
    background: #fff;
}
.cr-export-dialog__title-wrap {
    min-width: 0;
    padding-right: 4px;
}
.cr-export-dialog__title {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px 8px;
    font-size: 15px;
    font-weight: 600;
    color: #1f2937;
    line-height: 1.25;
}
.cr-export-dialog__title-text {
    flex-shrink: 0;
}
.cr-export-dialog__title .el-icon-download {
    width: 24px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    border-radius: 6px;
    background: linear-gradient(135deg, #ecf5ff 0%, #e8f4ff 100%);
    color: var(--btn-primary, #2563eb);
    font-size: 14px;
    flex-shrink: 0;
}
.cr-export-dialog__meta {
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    font-size: 12px;
    font-weight: 400;
    line-height: 1.25;
    color: #64748b;
}
.cr-export-dialog__meta-sep {
    color: #cbd5e1;
}
.cr-export-dialog__body {
    padding: 12px 14px 14px;
    display: flex;
    flex-direction: column;
}
.cr-export-sheet-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}
.cr-export-scope-opt {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    padding: 10px 12px;
    border: 1px solid #e8edf3;
    border-radius: 8px;
    background: #f8fafc;
    cursor: pointer;
    margin: 0;
}
.cr-export-scope-block {
    display: flex;
    flex-direction: column;
    gap: 6px;
}
.cr-export-scope-row {
    display: flex;
    gap: 8px;
}
.cr-export-scope-row .cr-export-scope-opt {
    flex: 1;
    min-width: 0;
}
.cr-export-scope-hint {
    margin: 0;
    padding: 0 2px;
    font-size: 11px;
    line-height: 1.35;
    color: #64748b;
}
.cr-export-scope-opt.is-on {
    border-color: #b3d8ff;
    background: #f0f7ff;
}
.cr-export-scope-opt.is-on .cr-export-sheet-row__check {
    border-color: var(--btn-primary, #2563eb);
    background: var(--btn-primary, #2563eb);
}
.cr-export-scope-opt.is-on .cr-export-sheet-row__check .el-icon-check {
    opacity: 1;
    transform: scale(1);
}
.cr-export-scope-opt__text {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
}
.cr-export-scope-opt__text strong {
    font-size: 13px;
    font-weight: 600;
    color: #1e293b;
    line-height: 1.3;
}
.cr-export-scope-opt__text em {
    font-style: normal;
    font-size: 11px;
    line-height: 1.35;
    color: #64748b;
}
.cr-export-scope-opt.is-on .cr-export-scope-opt__text em {
    color: #3b82f6;
}
.cr-export-sheet-row {
    padding: 10px 12px 12px;
    border: 1px solid #e8edf3;
    border-radius: 8px;
    background: #fff;
}
.cr-export-sheet-row.is-checked {
    border-color: #b3d8ff;
    background: #f8fbff;
}
.cr-export-sheet-row__head {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    cursor: pointer;
    margin-bottom: 0;
}
.cr-export-sheet-row.is-checked .cr-export-sheet-row__head {
    margin-bottom: 10px;
}
.cr-export-sheet-row__label {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
}
.cr-export-sheet-row__input {
    position: absolute;
    opacity: 0;
    pointer-events: none;
}
.cr-export-sheet-row__check {
    width: 16px;
    height: 16px;
    border-radius: 4px;
    border: 1.5px solid #cbd5e1;
    background: #fff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: all 0.15s ease;
}
.cr-export-sheet-row__check .el-icon-check {
    font-size: 11px;
    color: #fff;
    opacity: 0;
    transform: scale(0.6);
}
.cr-export-sheet-row.is-checked .cr-export-sheet-row__check {
    border-color: var(--btn-primary, #2563eb);
    background: var(--btn-primary, #2563eb);
}
.cr-export-sheet-row.is-checked .cr-export-sheet-row__check .el-icon-check {
    opacity: 1;
    transform: scale(1);
}
.cr-export-sheet-row__title {
    font-size: 13px;
    font-weight: 600;
    color: #1e293b;
    line-height: 1.3;
}
.cr-export-sheet-row__badge {
    font-size: 11px;
    line-height: 1.35;
    padding: 0;
    border-radius: 0;
    background: transparent;
    color: #64748b;
    align-self: flex-start;
}
.cr-export-sheet-row.is-checked .cr-export-sheet-row__badge {
    background: transparent;
    color: #3b82f6;
}
.cr-export-date-panel {
    margin-left: 24px;
    padding: 8px 10px;
    border-radius: 8px;
    background: #f1f5f9;
    border: 1px solid #e8edf3;
}
.cr-export-sheet-row.is-checked .cr-export-date-panel {
    background: #eef6ff;
    border-color: #dbeafe;
}
.cr-export-date-row {
    display: flex;
    align-items: center;
    gap: 8px;
}
.cr-export-date-pick.el-date-editor {
    flex: 1;
    width: auto !important;
    min-width: 0;
}
.cr-export-date-pick.el-input--small .el-input__inner {
    height: 30px;
    line-height: 30px;
    padding-left: 28px;
    padding-right: 8px;
    font-size: 12px;
    font-weight: 500;
    color: #334155;
    font-variant-numeric: tabular-nums;
    letter-spacing: 0.01em;
    border-radius: 7px;
    border-color: #e2e8f0;
    background: #fff;
    transition: border-color 0.18s ease, box-shadow 0.18s ease;
}
.cr-export-date-pick .el-input__prefix {
    left: 6px;
}
.cr-export-date-pick .el-input__icon {
    width: 22px;
    font-size: 13px;
    color: #94a3b8;
    line-height: 30px;
}
.cr-export-date-pick.el-input--small .el-input__inner:hover {
    border-color: #b6d4fe;
}
.cr-export-date-pick.el-input--small .el-input__inner:focus {
    border-color: var(--btn-primary, #2563eb);
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.12);
}
.cr-export-date-sep {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: #eef2f7;
    color: #94a3b8;
}
.cr-export-date-sep .el-icon-right {
    font-size: 11px;
    font-weight: 700;
}
.cr-export-dialog__footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    flex-wrap: wrap;
}
.cr-export-dialog__loading-hint {
    flex: 1;
    min-width: 0;
    margin: 0;
    font-size: 12px;
    color: #64748b;
    line-height: 1.4;
}

/* 学生明细弹窗（append-to-body；覆盖全局 .el-dialog .el-select{display:block}）。最后修改：2026-09-20 */
.el-dialog.cr-student-detail-dialog {
    border-radius: 10px;
    overflow: hidden;
}
.el-dialog.cr-student-detail-dialog .el-dialog__header {
    padding: 14px 44px 10px 16px;
    border-bottom: 1px solid #eef1f5;
}
.el-dialog.cr-student-detail-dialog .el-dialog__title {
    font-size: 15px;
    font-weight: 600;
    color: #303133;
    line-height: 1.4;
}
.el-dialog.cr-student-detail-dialog .el-dialog__body {
    padding: 12px 16px 14px !important;
}
.el-dialog.cr-student-detail-dialog .cr-student-detail-toolbar {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
}
.el-dialog.cr-student-detail-dialog .cr-student-detail-keyword.el-input {
    width: 200px !important;
    flex: 0 0 200px;
}
.el-dialog.cr-student-detail-dialog .cr-student-detail-state.el-select {
    display: inline-block !important;
    width: 120px !important;
    flex: 0 0 120px;
}
.el-dialog.cr-student-detail-dialog .cr-student-detail-count {
    margin-left: auto;
    font-size: 12px;
    color: #909399;
    white-space: nowrap;
}
.el-dialog.cr-student-detail-dialog .cr-student-detail-table {
    width: 100%;
}
.el-dialog.cr-student-detail-dialog .cr-student-detail-pager {
    margin-top: 10px;
    display: flex;
    justify-content: flex-end;
}
</style>
